import React from 'react';
import { Box } from '@mui/system';
import { Dayjs } from 'dayjs';
import { EsgDatePickerField, Label16SemiBold } from 'components';
import { getDateFormatset } from 'utils';
import { fieldStyles } from '../styles';

interface DateRangePickerProps {
    viewFromDate: Dayjs | null;
    viewToDate: Dayjs | null;
    onFromDateChange: (date: Dayjs | null) => void;
    onToDateChange: (date: Dayjs | null) => void;
    fromError?: string;
    toError?: string;
}

export const DateRangePicker = ({
    viewFromDate,
    viewToDate,
    onFromDateChange,
    onToDateChange,
    fromError,
    toError,
}: DateRangePickerProps) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '300px' }}>
        <Label16SemiBold>Select Date Range</Label16SemiBold>
        <Box sx={{ display: 'flex', gap: '6px' }}>
            <EsgDatePickerField
                views={['year', 'month', 'day']}
                placeholdervalue={getDateFormatset()}
                format={getDateFormatset()}
                openTo="year"
                onChange={onFromDateChange}
                value={viewFromDate}
                label="View from *"
                clearDate={false}
                textFieldProps={{
                    sx: fieldStyles,
                    error: !!fromError,
                    helperText: fromError,
                    inputProps: { 'aria-label': 'View from date' },
                }}
            />
            <EsgDatePickerField
                views={['year', 'month', 'day']}
                placeholdervalue={getDateFormatset()}
                format={getDateFormatset()}
                openTo="year"
                onChange={onToDateChange}
                value={viewToDate}
                label="View to *"
                clearDate={false}
                textFieldProps={{
                    sx: fieldStyles,
                    error: !!toError,
                    helperText: toError,
                    inputProps: { 'aria-label': 'View to date' },
                }}
            />
        </Box>
    </Box>
);